




















import Vue from "vue";
import _ from "lodash";
import "@/plugins/veeValidate.js";
import { ValidationProvider } from "vee-validate";

export default Vue.extend({
    name: "FieldCustom",
    components: {
        ValidationProvider
    },
    props: {
        name: {
            type: String,
            required: true
        },
        label: {
            type: String,
            required: true
        },
        value: {
            type: String,
            required: true
        },
        clearable: {
            type: Boolean,
            default: () => {
                return false;
            }
        },
        rightIcon: String,
        iconPrefix: {
            type: String
        },
        rules: Array,
        placeholder: {
            type: String,
            required: false
        },
        type: {
            required: false,
            default: "text"
        }
    },
    data() {
        return {
            inputValue: this.value,
            inputRules: this.rules,
            inputPlaceholder: _.defaultTo(this.placeholder, this.$t("common.placeholder.input"))
        };
    },
    methods: {
        inputChange() {
            this.$emit("input", _.defaultTo(this.inputValue, ""));
        },
        clickRightIcon() {
            this.$emit("click-right-icon");
        }
    },
    computed: {
        fieldRules() {
            const rulesObj: any = this.inputRules;
            return _.join(rulesObj, "|");
        }
    },
    watch: {
        value(newVal) {
            this.inputValue = newVal;
        }
    }
});
